module.exports = __webpack_public_path__ + "static/img/page_04.d37c251.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page_04.jpeg
// module id = bCxp
// module chunks = 0